
import { Button, Row, Col, Grid, Image } from "antd";
import { useStyles } from "../styles";
import Isuccess from "../assets/icon/ic-done2.svg";
import IDoneGC from "../assets/icon/ic-doneGC.svg";
import IGiohang from "../assets/icon/ic-giohang.svg";
import BGMB from "../assets/images/bg-mb.webp";
import BGDK from "../assets/images/bgdk.webp";
import QR365Android from "../assets/images/qr-365-android.jpg";
import QR365IOS from "../assets/images/qr-365-ios.jpg";
import { formatMoney, renderSelectMethod } from "./.././../../extra/utils";
import MdShowlink from "../components/mdShowlink";

const { useBreakpoint } = Grid;

export default function Step3({ state, dispatch, isApp, code }) {
  const { dataStep2 } = state;
  const dataTran = JSON.parse(localStorage.getItem("dataTran"));
  const isMobile = useBreakpoint().xs;
  const isCI186 = JSON.parse(localStorage.getItem("dataTran"))?.product_code === 'ci186';


  const css = {
    boxItem: {
      display: isMobile ? "flex" : 'grid',
      alignItems: isMobile ? "flex-start" : 'center',
      justifyContent: isMobile ? "space-between" : 'cnter',
      gap: isMobile ? 0 : 10,
      with: '100%'
    },
    leftContent: {
      fontSize: isMobile ? 14 : 16,
      color: "#61646D",
      textAlign: isMobile ? "left" : 'center',
    },
    rigthItem: {
      fontSize: isMobile ? 14 : 18,
      color: "#343A40",
      textAlign: isMobile ? "right" : 'center',
      fontWeight: 500,
    },
    boxQR: {
      padding: 10, borderRadius: 16, background: '#fff', width: '100%', margin: '0px auto', marginTop: 10, boxShadow: '0px 2px 3px 0px #00000014'
    }
  };

  const renderQR = (src, text) => (
    <>
      <Image
        width={isMobile ? "80px" : '90px'}
        height={isMobile ? "80px" : '90px'}
        alt="qr"
        src={src || ""}
      />
      <div style={{ fontSize: isMobile ? 12 : 14, color: "#61646D", marginTop: 10 }}>
        {text}
      </div>
    </>
  );

  return (
    <div style={{
      minHeight: "100vh",
      backgroundImage: isMobile ? `url(${BGMB})` : `url(${BGDK})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
      display: isMobile ? '' : 'grid',
      alignItems: isMobile ? '' : 'center'
    }}>
      <MdShowlink {...{ dispatch, isApp, state }} />
      <div style={{
        padding: isMobile ? '20px 20px 29px 20px' : 30, textAlign: 'center',
        background: isMobile ? '#ffffff20' : '#ffffff50',
        margin: isMobile ? 0 : '10px 16%',
        borderRadius: isMobile ? '' : 50,
        boxShadow: isMobile ? '' : ' 0px 6px 12px 0px #0000001A',
        border: isMobile ? '' : '3px solid #ffffff',
        minHeight: isMobile ? 'calc(100vh - 50px)' : '',
        backdropFilter: 'blur(8px)'
      }}>
        <div>
          <Row gutter={[10, 20]}>
            <Col xs={24}>
              <img src={isCI186 ? Isuccess : IDoneGC} width={isMobile ? 70 : 80} alt="icon" />
            </Col>
            <Col xs={24} style={{ marginBottom: isMobile ? 0 : 20 }}>
              <div
                style={{
                  fontSize: isMobile ? 24 : 28,
                  fontWeight: 700,
                  // color: "#0B7CE4",
                }}
              >
                Thanh toán thành công
              </div>
            </Col>

            {
              isCI186 &&
              <Col xs={24} style={{ marginBottom: isMobile ? 0 : 20 }}>
                <div style={{ fontSize: isMobile ? 14 : 16, lineHeight: 1.3 }}>
                  <b>Chúc mừng quý khách!</b>
                  <div style={{ textAlign: 'center' }}>
                    Yêu cầu bảo hiểm của Quý Khách đã được Chubb Life Việt Nam tiếp nhận. Hợp đồng của Quý khách sẽ được thẩm định và phát hành trong vòng 24 giờ tới, bộ hợp đồng sẽ được Chubb Life Việt Nam gửi đến email của Quý Khách. Ngoài ra có thể theo dõi trạng thái hợp đồng của mình tại ứng dụng <span style={{ color: '#FB7800' }}>BH365</span>. Để tải ứng dụng <span style={{ color: '#FB7800' }}>BH365</span> vui lòng quét mã QR bên dưới
                  </div>
                </div>
              </Col>
            }

            <Col xs={24} xl={8}>
              <div style={css.boxItem}>
                <div style={{ ...css.leftContent, minWidth: 80 }}>
                  Mã giỏ hàng
                </div>
                <div style={css.rigthItem}>{dataTran?.transCode || '-'}</div>
              </div>
            </Col>

            <Col xs={24} xl={8}>
              <div style={css.boxItem}>
                <div style={{ ...css.leftContent, minWidth: 130 }}>
                  Hình thức thanh toán
                </div>
                <div style={css.rigthItem}>
                  {dataTran?.free
                    ? "Tiền thưởng"
                    : renderSelectMethod(dataTran?.method)}
                </div>
              </div>
            </Col>

            <Col xs={24} xl={8}>
              <div style={css.boxItem}>
                <div style={{ ...css.leftContent, minWidth: 80 }}>Tổng tiền</div>
                <div style={css.rigthItem}>{formatMoney(dataTran?.fees)} VNĐ</div>
              </div>
            </Col>

            <Col xs={24}>
              <div style={{ height: 0.5, width: '100%', background: '#C0C0C0' }}></div>
            </Col>

            <Col xs={24}>
              <div style={{ textAlign: isMobile ? 'justify' : 'center', color: '#61646D', fontSize: isMobile ? 14 : 16, }}>
                Chúng tôi đã gửi SMS vào số điện thoại mà Quý khách đã đăng ký
              </div>
            </Col>

            {
              (dataTran?.utm_medium !== 'share') &&
              <Col xs={24} style={{ marginBottom: isMobile ? 0 : 20 }}>
                <Button
                  className={'glow-on-hover btn-glow js-inview'}
                  icon={<img src={IGiohang} width={isMobile ? 15 : 20} alt="icon" style={{ marginRight: 10, marginBottom: isMobile ? -3 : -3 }} />}
                  onClick={() => dispatch("continue")}
                  style={{
                    background: isCI186 ?
                      `linear-gradient(180deg, #00B3FF -20.16%, #006FFF 64.98%, #003478 121.51%), 
                    radial-gradient(65.39% 66.51% at 31.97% 19.67%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%)`:
                      `linear-gradient(135deg, #27C83D 12.5%, #009B4B 50%, #007438 87.5%),
radial-gradient(65.39% 66.51% at 31.97% 19.67%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%)`
                    ,
                    color: '#fff',
                    borderRadius: isMobile ? 12 : 16,
                    width: 'fit-content',
                    padding: isMobile ? '5px 10px' : '10px 15px',
                    // border: 'none',
                    fontSize: isMobile ? 14 : 16,
                  }}
                >
                  Tiếp tục mua hàng
                </Button>
              </Col>
            }

            <Col xs={24}>
              {
                isCI186 ?
                  <div style={{ display: 'flex', gap: 30 }}>
                    <div style={css.boxQR}>
                      <div style={{ textAlign: 'center' }}>
                        {renderQR(QR365Android, ' Quét mã QR để tải ứng trên hệ điều hành android')}
                      </div>
                    </div>
                    <div style={css.boxQR}>
                      <div style={{ textAlign: 'center' }}>
                        {renderQR(QR365IOS, 'Quét mã QR để tải ứng trên hệ điều hành IOS')}
                      </div>
                    </div>
                  </div>
                  :
                  <div style={{ ...css.boxQR, width: isMobile ? 120 : 230 }}>
                    <div style={{ textAlign: 'center' }}>
                      {renderQR(dataStep2.completeInfo?.qr, 'Quét mã QR để thuận tiện tra cứu.')}
                    </div>
                  </div>
              }
            </Col>

            <Col xs={24}>
              <div style={{ width: "100%", textAlign: 'center' }}>
                {
                  isCI186 ?
                    <div style={{ fontSize: isMobile ? 14 : 16, lineHeight: 1.3 }}>
                      <div style={{ textAlign: 'center' }}>
                        Vui lòng kiểm tra email và tin nhắn hoặc truy cập ứng dụng <span style={{ color: '#FB7800' }}>BH365</span> để tra cứu và quản lý hợp đồng bảo hiểm của bạn sau khi được Chubb Life Việt Nam phát hành.
                      </div>
                    </div> :
                    <div style={{ color: "#61646D", fontSize: isMobile ? 14 : 16, }}>
                      Vui lòng kiểm tra tin nhắn hoặc truy cập website
                      <a
                        href={dataStep2?.completeInfo?.tracuu || "//tracuu.globalcare.vn"}
                        target="_blank"
                        style={{ textDecoration: "none", color: "#FB7800" }}
                      > tracuu.globalcare.vn </a> để tra cứu và tải giấy chứng nhận bảo hiểm.
                    </div>
                }
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}